import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY in frontend/.env");
}

// DEFER-P4-E: REACT_APP_BACKEND_URL must include the https:// scheme.
// Without it, CRA bakes a scheme-less host into the bundle which the browser
// resolves as a relative path (e.g. window.location.origin + /<host>/api/...).
// This hung /dashboard for ~5 min during the 04-02 cutover before being caught.
// Fail fast at boot with a readable error instead of debugging a hung page.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL || !/^https?:\/\//.test(BACKEND_URL)) {
  const msg = `REACT_APP_BACKEND_URL must be set and start with https:// (got: ${BACKEND_URL ?? "undefined"})`;
  // Render a visible error to the DOM AND throw — loud, fast, unambiguous.
  document.body.innerHTML = `<pre style="padding:2rem;font-family:monospace;color:#c00;background:#fff">FATAL BUILD ERROR: ${msg}</pre>`;
  throw new Error(msg);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
